import React from 'react'
import Menu from '../src/Menu'

//import './App.css';
import './asset/css/App.css'
import Login from './Login';

import {useState} from 'react';

function App() {

const [name,setName] = useState(localStorage.getItem('user-info'))
window.addEventListener("beforeunload", () => localStorage.removeItem('user-info'));

const ShowPage = ()=>{

if(name)
  {
   return(
         <Menu />  
     );
   }
  else
  {
    return(
    <Login onChange={handleChange} />  
   );
 }

}

function handleChange(newValue) {

      setName(newValue);
    }

  return (

    <div className="App">
       <ShowPage /> 
    </div>
  );
}

export default App;




